// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAusdm } from "../../../icons/mono/build/icon-ausdm.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AusdmIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAusdm.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AusdmIcon.displayName = 'AusdmIcon';
}

export default AusdmIcon;